import { isProjectArchived } from "./projectVisibility";

/** Derived hub filter. Not a stored project status. */
export const PROJECT_HUB_OVERDUE_TASKS = "overdue_tasks";

export const PROJECT_HUB_STATUS_FILTERS = Object.freeze([
  { value: "active", label: "Active" },
  {
    value: PROJECT_HUB_OVERDUE_TASKS,
    label: "Overdue Tasks",
    title: "Projects with at least one overdue task",
  },
  { value: "archived", label: "Archived" },
]);

/** Default hub entry is Active. Only the explicit overdue-tasks token selects that filter. */
export function resolveProjectHubFilter(value) {
  if (value === PROJECT_HUB_OVERDUE_TASKS || value === "archived") return value;
  return "active";
}

/**
 * Read a hub-open options object. Click events and normal navigation
 * do not carry the token, so they return the default Active filter.
 */
export function attentionFilterFromHubOpen(options) {
  if (
    options &&
    typeof options === "object" &&
    options.attentionFilter === PROJECT_HUB_OVERDUE_TASKS
  ) {
    return PROJECT_HUB_OVERDUE_TASKS;
  }
  return null;
}

/**
 * `overdueProjectIds` is the set from `projectIdsWithOverdueTasks`.
 * Missing ids match nothing so a not-yet-loaded task list cannot show
 * every project.
 */
export function projectMatchesHubFilter(project, statusFilter, context = {}) {
  if (statusFilter === PROJECT_HUB_OVERDUE_TASKS) {
    const ids = context.overdueProjectIds;
    if (!ids || typeof ids.has !== "function") return false;
    return ids.has(project?.project_id);
  }
  if (statusFilter === "archived") {
    return isProjectArchived(project);
  }
  return !isProjectArchived(project);
}
